import React from 'react';
import {Form, Label, Segment, Accordion, Dropdown, TextArea, Button} from 'semantic-ui-react';
import axios from 'axios';
import '../css/QAdminAPI.css'


const activeOptions = [
    { key: 'true', text: 'True', value:'true'},   
    { key: 'false', text: 'False', value:'false'},
]

class QToggleOrgActivate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {organization:null, activate:'true', response:null}
        }

    // Sent download link to the user email.
    toggleOrgActivate = () => {
        if (!this.state.organization){ 
        alert("Please enter an organization.")
        return
        }
        this.setState({response: ""})
        const url = "/admin/activate/" + this.state.organization 
        const params = {active: this.state.activate, token:this.props.getToken()}
        let result = axios({method: "put", url:url, params: params})
        result.then((response)=> {this.setState({response: response.data.response}); this.props.getOrganizations()},
                    (error) => {this.setState({response: error.response.data.detail}); this.props.getUser()})

    }

    render () {
        return (
            <Segment  className='putSegmentStyle'>
            <Accordion.Title 
            active={this.props.activeIndex === this.props.index}
            content= {(
                <>
                <Label className='methodLabel' color='orange'> Activate/deactivate an organization </Label>
                </>
                )} 
                index={this.props.index}
                onClick={this.props.handleClick}
            />
            <Accordion.Content
            active={this.props.activeIndex === this.props.index} 
            content={(
            <>
            <Form>
                <Form.Field >
                <label>Organization</label>
                <Dropdown placeholder='Select organization' selection options={this.props.organizationNames}
                onChange={(event, {name, value}) => this.setState({organization: value})}/>
                </Form.Field>
                <Form.Field >
                <label>Active</label>
                <Dropdown placeholder='Active'  selection options={activeOptions} defaultValue={this.state.activate} 
                onChange={(event, {name, value}) => this.setState({activate: value})}/>
                </Form.Field>
                <Form.Field>
                <Button className="submitBtn" fluid onClick={(e) => this.toggleOrgActivate()}>
                Submit
                </Button>
                </Form.Field> 
                <Form.Field>
                <label>Response</label>
                <TextArea value={this.state.response}/>
                </Form.Field>     
            </Form>
            </>
            )} />
            </Segment>
        )
    }

}

export default QToggleOrgActivate